module.exports = __webpack_public_path__ + "img/2_2-residenziale-villette-1.07c61f08.png";